






import { computed, ComputedRef, defineComponent, PropType } from "@vue/composition-api"
import { IStudies } from "@/shared/models/api/study-choice-studies-model"

export default defineComponent({
    name: "HeadingCount",
    props: {
        heading: {
            type: String,
            required: true,
            default: ""
        },
        countAble: {
            type: [] as PropType<IStudies>,
            required: true,
            default: ""
        }
    },
    setup: () => {
        const headingCount: ComputedRef<string> = computed((props): string => {
            return props.heading?.replace(/:studies/g, props.countAble?.length.toString())
        })
        
        return {
            headingCount
        }
    }
})
